import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	addTitle: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.add-title.no-translate',
		defaultMessage: 'Create routing rule',
		description: 'Title of add routing rule modal',
	},
	editTitle: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.edit-title.no-translate',
		defaultMessage: 'Edit routing rule',
		description: 'Title of edit routing rule modal',
	},
	cloneTitle: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.edit-title.no-translate',
		defaultMessage: 'Duplicate routing rule',
		description: 'Title of clone routing rule modal',
	},
	ruleTitle: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.rule-title.no-translate',
		defaultMessage: 'Name',
		description: 'Label of rule title input',
	},
	ruleTitlePlaceholder: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.rule-title-placeholder.no-translate',
		defaultMessage: 'Enter a name for the rule',
		description: 'Placeholder of rule title input',
	},
	followingConditions: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.following-conditions.no-translate',
		defaultMessage: 'Alert Filters',
		description: 'The seperator title of form sections',
	},
	notifyInput: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.notify-input.no-translate',
		defaultMessage: 'Filter alerts',
		description: 'Label of notify input',
	},
	restrictToTimeInterval: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.restrict-to-time-interval.no-translate',
		defaultMessage: 'Time slots',
		description: 'Label of restrict to time interval section',
	},
	specificInterval: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.specific-interval.no-translate',
		defaultMessage: 'Route during specified time slots only',
		description: 'Label of specific interval checkbox',
	},
	thenRouteUsing: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.then-route-using.no-translate',
		defaultMessage: 'Route target',
		description: 'The seperator title of form sections',
	},
	routeTo: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-to.no-translate',
		defaultMessage: 'Route to',
		description: 'Label of route to select',
	},
	routeTargetTooltipContent: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-target-tooltip-content.no-translate',
		defaultMessage: 'Select a target to route your alerts to',
		description: 'Tooltip content message to introduce route target section',
	},
	routeTargetTooltipLabel: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-target-tooltip-label.no-translate',
		defaultMessage: 'More about route target',
		description: `Label of the tooltip info button for accessibility`,
	},
	forEveryday: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.for-everyday.no-translate',
		defaultMessage: 'Daily',
		description: 'Label of for everyday radio',
	},
	customizeDays: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.customize-days.no-translate',
		defaultMessage: 'Custom',
		description: 'Label of customize days radio',
	},
	from: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.from.no-translate',
		defaultMessage: 'From',
		description: 'Label of date time pickers: from',
	},
	to: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.to.no-translate',
		defaultMessage: 'To',
		description: 'Label of date time pickers: to',
	},
	timezone: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.timezone.no-translate',
		defaultMessage: 'Select timezone',
		description: 'Label of timezone select',
	},
	cancel: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.cancel.no-translate',
		defaultMessage: 'Cancel',
		description: 'Label of close modal button',
	},
	add: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.add.no-translate',
		defaultMessage: 'Create',
		description: 'Label of submit add routing rule button',
	},
	update: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.update.no-translate',
		defaultMessage: 'Update',
		description: 'Label of update routing rule button',
	},
	clone: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.clone.no-translate',
		defaultMessage: 'Duplicate',
		description: 'Label of clone routing rule button',
	},
	scheduleWarning: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.schedule-warning.no-translate',
		defaultMessage:
			'You’ve selected a schedule to route the alerts. This means, when you receive an alert according to this routing rule, we’ll ignore other escalation policies the alerts might be subjected to, and route them directly to the schedule you’ve selected.',
		description: 'Warning message that shown when user select route to field schedule',
	},
	routeDeletedWarning: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-deleted-warning.no-translate',
		defaultMessage:
			'The team selected for routing no longer exists. Select a different route target.',
		description: 'Warning message that shown when routing rule is not exist anymore',
	},
	deletedTeam: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.deleted-team-placeholder.no-translate',
		defaultMessage: 'Deleted team',
		description: 'Indicator message when team is not exist anymore',
	},
	conditionRequired: {
		id: 'eoc.routing-rules.ui.add-routing-rules-modal.condition-required.no-translate',
		defaultMessage: 'Enter a key for the condition work',
		description: 'Error message that shown when field free form value is not exist',
	},
	fieldRequired: {
		id: 'eoc.routing-rules.ui.common.required.no-translate',
		defaultMessage: 'This field is required',
		description: 'Error message that shown required input is empty',
	},
	routeToRequired: {
		id: 'eoc.routing-rules.ui.common.route-to-required.no-translate',
		defaultMessage: 'Select a different route target.',
		description: 'Error message that shown route to select is not selected',
	},
});

export default messages;
